import React, {Fragment, useState, useEffect} from 'react';
import Formulario from './components/Formulario';
import Cita from './components/Cita';

//npm start

function App() {

  // citas en local Storage
  let citasIniciales = JSON.parse(localStorage.getItem('citas'));
  if(!citasIniciales){
    citasIniciales = [];
  }

  //Agregor de Citas
  const [citas, guardarCitas] = useState(citasIniciales);
  

  //use effect para ralizar  ciertas operaciones cuando el state cambie
  useEffect( () => {
    let citasIniciales = JSON.parse(localStorage.getItem('citas'));
    if(citasIniciales){
      localStorage.setItem('citas', JSON.stringify(citas));
    } else {
      localStorage.setItem('citas', JSON.stringify([]));
    }
  }, [citas] );

  

  //Funcion que tome las citas actuales y agregue la nueva
  const crearCita = cita => {
    //console.log(cita);
    guardarCitas([
      ...citas, cita
    ]);
  }

  //Elmina una sita por el id
  const eliminarCita = id => {
    console.log(id);
    const nuevaCitas = citas.filter(cita => cita.id !== id);
    guardarCitas(nuevaCitas);
  }

  //mensaje condicional
  const titulo = citas.length === 0 ? 'No hay citas' : 'Administra tus citas'  

  return (
    <Fragment>
      <h1>Administrador de Pacientes</h1>
      <div className="container">
        <div className="row">
          <div className="one-half column">
            <Formulario 
              crearCita={crearCita}
            />
          </div>
          <div className="one-half column">
            <h2> {titulo}</h2>
            {citas.map(cita => (
              <Cita
                key={cita.id}
                cita={cita}
                eliminarCita={eliminarCita}           
              />
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default App;
